<script lang="ts">
import type { PlaceholderAvatarProps } from '../PlaceholderAvatar.vue'

export type ProjectAvatarProps = PlaceholderAvatarProps
</script>

<script setup lang="ts">
import placeholder from '../assets/project.svg'
import PlaceholderAvatar from '../PlaceholderAvatar.vue'

const props = withDefaults(defineProps<ProjectAvatarProps>(), {
  size: 'sm',
})
</script>

<template>
  <PlaceholderAvatar v-bind="props" :placeholder="placeholder" />
</template>
